import { connect } from 'react-redux';
import LoadingInformationCard from '.';

const mapStateToProps = state => ({
  airports: state.common.airports,
});

export default connect(mapStateToProps)(LoadingInformationCard);
